import {createRouter, createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },

  {
    path: '/project/:slug',
    name: 'project',
    component: () => import(/* webpackChunkName: "project" */ '../views/Project.vue')
  },

  {
    path: '/preview-project/',
    name: 'preview-project',
    component: () => import(/* webpackChunkName: "project" */ '../views/Project.vue')
  },


  {
    path: '/projects',
    name: 'projects',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue')
  },

  {
    path: '/preview-news/',
    name: 'preview-news',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },


  {
    path: '/news/:slug',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },

  {
    path: '/studio',
    name: 'studio',
    component: () => import(/* webpackChunkName: "studio" */ '../views/Studio.vue')
  },

  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
  
  {
    path: '/:slug',
    name: 'page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },
  
  {
    path: '/preview-page',
    name: 'preview-page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },

  {
    path: '/preview-home',
    name: 'preview-home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },


  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
]

const base_url = process.env.NODE_ENV === 'production' ? '/' : '/';
  
const router = createRouter({
  history: createWebHistory(base_url),
  routes
});

export default router;
